import React from 'react';
import classNames from 'classnames';
import { shape, string, number } from 'prop-types';
import { formatPhoneNumber } from '../../utils/helpers';

import styles from './StoreCard.module.scss';

export const StoreCard = ({ store }) => {
  const {
    availableQty, name, phone, storeId, address, toolRentalPhone, services
  } = store;
  const { street, city, state, postalCode } = address;
  const { toolRental } = services;
  return (
    <div className={classNames(styles['rental-fulfillment__location'])}>
      <div className="u--paddingBottom">
        <b>{ toolRental ? `Your Nearest Rental Center is: ${name} ${storeId}`
          : `Your Nearest Store is: ${name} ${storeId}` }
        </b>
      </div>
      <span>
        {street}, {city}, {state}, {postalCode}
      </span>
      <div>
        { !toolRentalPhone ? `Phone: ${formatPhoneNumber(phone)}`
          : `Rental: ${formatPhoneNumber(toolRentalPhone)}` }
      </div>
    </div>
  );
};

StoreCard.propTypes = {
  store: shape({
    name: string,
    storeId: string,
    distance: string,
    toolRentalPhone: string,
    address: shape({
      street: string,
      city: string,
      state: string,
      postalCode: string,
    }),
  }).isRequired
};
